export interface LoginRequest {
  email: string | null;
  password: string | null;
  returnUrl: string | null;
  preferredUserType?: UserType;
}

export interface LoginResponse {
  requiresEmailConfirmation: boolean;
  returnUrl: string | null;
}

export interface RegisterAgentRequest {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  password: string;
}

export interface RegisterUserRequest {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  password: string;
  userType?: UserType;
}

export interface RegisterResponse {
  userId: string;
}

export enum UserType {
  Unspecified = "Unspecified",
  Agent = "Agent",
  AgencyManager = "AgencyManager",
  Landlord = "Landlord",
  Tenant = "Tenant",
  Admin = "Admin",
  Manager = "Manager",
}

export interface ProfileResponse {
  isLoggedIn: boolean;
}

export interface ConfirmEmailRequest {
  email: string | null;
  code: string | null;
}

export interface ResetPasswordRequest {
  email: string | null;
  resetCode: string | null;
  newPassword: string | null;
}

export interface ForgotPasswordRequest {
  email: string | null;
}

export interface ResendEmailConfirmationRequest {
  email: string | null;
}

export interface VerificationStatusRequest {
  inquiryId: string;
  status: string;
}

export interface LogoutResponse {
  redirectUrl: string;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

export interface RequestEmailChangeRequest {
  newEmail: string;
  currentPassword: string;
}

export interface ConfirmEmailChangeRequest {
  newEmail: string;
  code: string;
}
